{
  "id": "campaign-080",
  "name": "Rival Robo-Mower",
  "seed": "campaign:80",
  "generatorVersion": 3,
  "level": 80,
  "biome": "golf",
  "startDir": "N",
  "mowerRule": {
    "kind": "exclude",
    "mowers": ["fairway"]
  },
  "rows": [
    "...........D",
    "h...........",
    "....T...h...",
    "............",
    "............",
    ".sss........",
    ".s..........",
    "ss....w.....",
    "......w.....",
    "......ww....",
    "............",
    "............",
    "............",
    "............",
    "............",
    "S..........."
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 0,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 3
    }
  ],
  "critters": [],
  "rival": {
    "dir": "W",
    "speed": 60,
    "target": 0.6
  },
  "par": {
    "reel": 3900,
    "push": 3562,
    "selfPropelled": 3120,
    "tractor": 3320,
    "zeroTurn": 2233
  }
}
